import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'ServicoAnaliseTec'

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}`, data, config)
const GetAllByPci = (pciID, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${pciID}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIPci}/${resourceName}/${id}`, config)

export default {
  GetAll,
  GetAllByPci,
  Create,
  Update,
  Delete
}



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/tecserviceanalysis.js